import type {
  MCPRiskSubject,
  MCPRiskUnavailableReason,
} from '@kirin/api-client/contracts/mcp';

/** Why a row shows a dash instead of a risk value. */
export const MCP_RISK_UNAVAILABLE_COPY: Record<
  MCPRiskUnavailableReason,
  string
> = {
  remote: 'Not available for remote servers',
  local: 'Not available for local servers',
  gateway: 'Not available for gateway-managed servers',
  'no-record': 'No AgentMesh result for this version yet',
};

/** KIR-5345: names the local package a remote server's risk belongs to. */
export function mcpRiskSubjectCopy(subject: MCPRiskSubject): string {
  return `Assessed for ${subject.packageName}@${subject.version}, the package that runs locally for this server. Any remote server it connects to is not assessed.`;
}

/** Short cell caption naming the package a remote server's value is for. */
export function mcpRiskSubjectCaption(subject: MCPRiskSubject): string {
  return `via ${subject.packageName}`;
}
